import { enqueueSnackbar } from "notistack";
import { apiCall } from ".";
import { getSession } from "../handlers/getSession";
import { getTenant } from "../handlers/getTenant";
import { getErrorMessage } from "./errorMessages";
import { searchFinderApiCall } from "./apiReports";
import statuscode_es from "../translations/ES/statuscode.json";
import statuscode_en from "../translations/EN/statuscode.json";

const lang = localStorage.getItem("lang");
const language = lang === "es" ? statuscode_es : statuscode_en;

//function to handle errors and display them to the user
const showErrorMessage = (message) => {
  enqueueSnackbar(message, {
    variant: "error",
    preventDuplicate: true,
    autoHideDuration: 10000,
  });
};
// MAIN //
export const getInvestigation = async (alias = "") => {
  const session = getSession();
  const tenant = getTenant();
  if (!session) return;
  try {
    const resp = await apiCall.get(
      `${tenant}/api/reports/investigation/${alias}`,
      {
        headers: {
          IdToken: session.IdToken,
          Authorization: `Bearer ${session.AccessToken}`,
        },
      }
    );
    return resp.data;
  } catch (error) {
    showErrorMessage(
      getErrorMessage(error, "investigation")
    );
    console.error(error);
    throw error;
  }
};

export const createInvestigation = async ({ id, type, title }) => {
  const session = getSession();
  const tenant = getTenant();

  if (!session) return;
  try {
    const resp = await apiCall.post(
      `${tenant}/api/reports/investigation/create/`,
      { assigns: [id], type, title },
      {
        headers: {
          IdToken: session.IdToken,
          Authorization: `Bearer ${session.AccessToken}`,
        },
      }
    );
    return resp.data;
  } catch (error) {
    showErrorMessage(
      getErrorMessage(error, "investigation")
    );
    console.error(error.message);
    throw error;
  }
};

export const patchInvestigation = async (alias = "", form = {}) => {
  const session = getSession();
  const tenant = getTenant();
  if (!session) return;
  try {
    const resp = await apiCall.patch(
      `${tenant}/api/reports/investigation/${alias}`,
      form,
      {
        headers: {
          IdToken: session.IdToken,
          Authorization: `Bearer ${session.AccessToken}`,
        },
      }
    );
    enqueueSnackbar(`${language.data_update_successful}`, {
      variant: "success",
    });
    return resp.data;
  } catch (error) {
    showErrorMessage(
      getErrorMessage(error, "investigation")
    );
    console.error(error.message);
    throw error;
  }
};

export const getInvestigationListByReportId = async (id = "") => {
  const session = getSession();
  const tenant = getTenant();
  if (!session) return;
  try {
    const resp = await apiCall.get(
      `${tenant}/api/reports/investigation/list/${id}`,
      {
        headers: {
          IdToken: session.IdToken,
          Authorization: `Bearer ${session.AccessToken}`,
        },
      }
    );

    return resp.data;
  } catch (error) {
    showErrorMessage(
      getErrorMessage(error, "investigation")
    );
    console.error(error.message);
    throw error;
  }
};

// Get all offenders from investigation by Report ID
export const getOffendersListByReportId = async (id = "") => {
  const session = getSession();
  const tenant = getTenant();
  if (!session) return;
  try {
    const resp = await apiCall.get(
      `${tenant}/api/reports/investigation/offenders/${id}`,
      {
        headers: {
          IdToken: session.IdToken,
          Authorization: `Bearer ${session.AccessToken}`,
        },
      }
    );
    return resp.data;
  } catch (error) {
    showErrorMessage(
      getErrorMessage(error, "investigation")
    );
    console.error(error.message);
    // Prevents crash
    return [];
  }
};

// Get all victims from investigation by Report ID
export const getVictimsListByReportId = async (id = "") => {
  const session = getSession();
  const tenant = getTenant();
  if (!session) return;
  try {
    const resp = await apiCall.get(
      `${tenant}/api/reports/investigation/victims/${id}`,
      {
        headers: {
          IdToken: session.IdToken,
          Authorization: `Bearer ${session.AccessToken}`,
        },
      }
    );
    return resp.data;
  } catch (error) {
    showErrorMessage(
      getErrorMessage(error, "investigation")
    );
    console.error(error.message);
    // Prevents crash
    return [];
  }
};

// STATUS //
export const getInvestigationStatus = async (id = "") => {
  const session = getSession();
  const tenant = getTenant();
  if (!session) return;
  try {
    const resp = await apiCall.get(
      `${tenant}/api/reports/investigation/${id}/status`,
      {
        headers: {
          IdToken: session.IdToken,
          Authorization: `Bearer ${session.AccessToken}`,
        },
      }
    );
    return resp.data;
  } catch (error) {
    showErrorMessage(
      getErrorMessage(error, "investigation")
    );
    console.error(error.message);
    throw error;
  }
};

export const updateInvestigationStatus = async (status = "", id = "") => {
  const session = getSession();
  const tenant = getTenant();
  if (!session) return;
  try {
    const resp = await apiCall.put(
      `${tenant}/api/reports/investigation/${id}/status`,
      {
        headers: {
          IdToken: session.IdToken,
          Authorization: `Bearer ${session.AccessToken}`,
        },
      }
    );
    return resp.data;
  } catch (error) {
    showErrorMessage(
      getErrorMessage(error, "investigation")
    );
    console.error(error.message);
    throw error;
  }
};

// ASIGNS //
export const getInvestigationAssign = async (alias = "") => {
  const session = getSession();
  const tenant = getTenant();
  if (!session) return;
  try {
    const resp = await apiCall.put(
      `${tenant}/api/reports/investigation/${alias}/assign`,
      {
        headers: {
          IdToken: session.IdToken,
          Authorization: `Bearer ${session.AccessToken}`,
        },
      }
    );
    return resp.data;
  } catch (error) {
    showErrorMessage(
      getErrorMessage(error, "investigation")
    );
    console.error(error.message);
    throw error;
  }
};

export const updateInvestigationAssign = async (reports = [], id = "") => {
  const session = getSession();
  const tenant = getTenant();
  if (!session) return;
  try {
    const resp = await apiCall.patch(
      `${tenant}/api/reports/investigation/${id}/assign`,
      {
        headers: {
          IdToken: session.IdToken,
          Authorization: `Bearer ${session.AccessToken}`,
        },
      }
    );
    return resp.data;
  } catch (error) {
    showErrorMessage(
      getErrorMessage(error, "investigation")
    );
    console.error(error.message);
    throw error;
  }
};

export const createInvestigationAssign = async (alias, id) => {
  const session = getSession();
  const tenant = getTenant();
  if (!session) return;
  try {
    const resp = await apiCall.put(
      `${tenant}/api/reports/investigation/${alias}/assign`,
      { report: id },
      {
        headers: {
          IdToken: session.IdToken,
          Authorization: `Bearer ${session.AccessToken}`,
        },
      }
    );
    return resp.data;
  } catch (error) {
    showErrorMessage(
      getErrorMessage(error, "investigation")
    );
    console.error(error.message);
    throw error;
  }
};

export const deleteInvestigationAssign = async (alias, id) => {
  const session = getSession();
  const tenant = getTenant();
  if (!session) return;
  try {
    const resp = await apiCall.delete(
      `${tenant}/api/reports/investigation/${alias}/assign`,
      {
        data: {
          report: Number(id),
        },
        headers: {
          IdToken: session.IdToken,
          Authorization: `Bearer ${session.AccessToken}`,
        },
      }
    );
    return resp.data;
  } catch (error) {
    showErrorMessage(
      getErrorMessage(error, "investigation")
    );
    console.error(error.message);
    throw error;
  }
};

// Get investigation interview
export const getInterview = async (alias) => {
  const session = getSession();
  const tenant = getTenant();
  if (!session) return;

  try {
    const resp = await apiCall.get(
      `${tenant}/api/reports/investigation/interview/update?alias=${alias}`,
      {
        headers: {
          IdToken: session.IdToken,
          Authorization: `Bearer ${session.AccessToken}`,
        },
      }
    );
    return resp.data;
  } catch (error) {
    // 403 = usuario sin permisos sobre entrevistas. No propagar: si Promise.all
    // rechaza acá, getInvestigation (que sí cargó) tampoco se pinta y la pestaña
    // queda en blanco. Devolvemos shape vacío + bandera forbidden para que el
    // consumer pueda mostrar "Sin permiso" en la sección de Entrevistas.
    if (error?.response?.status === 403) {
      showErrorMessage(`${language.error_retrieving_data} (403)`);
      console.error(error.message);
      return { data: { interviews: [] }, forbidden: true };
    }
    showErrorMessage(
      `${language.error_retrieving_data} (${error.response?.status ?? ""})`
    );
    console.error(error.message);
    throw error;
  }
};

// Create investigation interview
export const createInterview = async (data) => {
  const session = getSession();
  const tenant = getTenant();
  if (!session) return;
  try {
    const resp = await apiCall.post(
      `${tenant}/api/reports/investigation/interview/update`,
      data,
      {
        headers: {
          IdToken: session.IdToken,
          Authorization: `Bearer ${session.AccessToken}`,
        },
      }
    );
    return resp.data;
  } catch (error) {
    showErrorMessage(
      `${language.error_occurred_while_attempting_send_information} (${error.response.status})`
    );
    console.error(error.message);
    throw error;
  }
};

// Update investigacion interview
export const updateInterview = async (data) => {
  const session = getSession();
  const tenant = getTenant();
  if (!session) return;
  try {
    const resp = await apiCall.put(
      `${tenant}/api/reports/investigation/interview/update`,
      data,
      {
        headers: {
          IdToken: session.IdToken,
          Authorization: `Bearer ${session.AccessToken}`,
        },
      }
    );
    return resp.data;
  } catch (error) {
    showErrorMessage(
      `${language.error_occurred_while_attempting_send_information} (${error.response.status})`
    );
    console.error(error.message);
    throw error;
  }
};

// Delete investigation interview
export const deleteInterview = async (alias, id) => {
  const session = getSession();
  const tenant = getTenant();
  if (!session) return;
  try {
    const params = new URLSearchParams({
      alias,
      interviews_id: id,
    });

    const resp = await apiCall.delete(
      `${tenant}/api/reports/investigation/interview/update?${params.toString()}`,
      {
        headers: {
          IdToken: session.IdToken,
          Authorization: `Bearer ${session.AccessToken}`,
        },
      }
    );

    return resp.data;
  } catch (error) {
    showErrorMessage(
      `${language.an_error_occurred_while_deleting_information} (${error.response.status})`
    );
    console.error(error.message);
    throw error;
  }
};

/**
 * Buscador de investigaciones (/search).
 *
 * Usa searchFinderApiCall igual que searchNavbarAPI para compartir la instancia
 * de axios del buscador (timeout largo y baseURL propia).
 */
export const searchInvestigationsAPI = async (data) => {
  const session = getSession();
  const tenant = getTenant();

  if (!session) return;

  try {
    const resp = await searchFinderApiCall(
      "get",
      `/${tenant}/api/investigation/search_list/`,
      {
        params: data,
        headers: {
          IdToken: session.IdToken,
          Authorization: `Bearer ${session.AccessToken}`,
        },
      }
    );

    return resp;
  } catch (error) {
    showErrorMessage(getErrorMessage(error, "reports"));
    console.error(error.message);
    throw error;
  }
};
